import { Button } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import {
    Edit,
    RadioButtonGroupInput, SaveButton,
    SimpleForm,
    TextField,
    TextInput, Toolbar, TopToolbar,
    useNotify,
    useRedirect,
    useRefresh
} from "react-admin";

const FormsRequestEdit = (props) => {

    const redirect = useRedirect()
    const notify = useNotify()
    const refresh = useRefresh()

    const onSuccess = ({ data }) => {
        notify('Fomulário criado com sucesso')
        redirect(`/formsRequest`, undefined, {}, {}, { data })
        refresh()
    }

    const Actions = ({ basePath, data }) => {
        return (
            <TopToolbar>
                <Button onClick={() => redirect(`${basePath}/${data.id}/show`)} startIcon={<Cancel />} children={'Cancelar'} />
            </TopToolbar>
        )
    };


    const CustomToolbar = props => (
        <Toolbar {...props}>
            <SaveButton />
        </Toolbar>
    );

    return (
        <Edit
            mutationMode="pessimistic"
            onSuccess={onSuccess}
            {...props}
            actions={<Actions />}
            hasShow={false}
        >
            <SimpleForm toolbar={<CustomToolbar />} >
                <TextField source={'user.name'} label={'Aluno'} />
                <RadioButtonGroupInput
                    source={'status'}
                    label={'Resultado'}
                    op
                    choices={[
                        { name: 'Deferir', id: 'approved', },
                        { name: 'Indeferir', id: 'rejected' }
                    ]} />
                <TextInput source={'observation'} label={'Observação de Retorno'} fullWidth variant={'outlined'} multiline rows={4} />
            </SimpleForm>
        </Edit>
    )
}


export default FormsRequestEdit;